import React, { FC, ReactNode } from 'react';
import ReactFrame from 'react-frame-component';
//@ts-ignore
//eslint-disable-next-line
import css from '!!raw-loader!../styles/index.css';
//@ts-ignore
//eslint-disable-next-line
import simplebar from '!!raw-loader!simplebar/dist/simplebar.min.css';

import { getColorDerivate, isElementVisible } from '../utils/popup-utils';
import { usePopupContext } from '../contexts/Settings';
import { isCandyRackSettings } from '../types';

interface Props {
  visible: boolean;
  children?: ReactNode;
}

const IFrame: FC<Props> = ({ visible, children }) => {
  const { settings } = usePopupContext();
  let rejectButtonVariables = '';
  if (isCandyRackSettings(settings)) {
    rejectButtonVariables = `
    --reject-button-background-color-1: ${
      settings.buttons.reject.colors.background
    };
    --reject-button-background-color-2: ${getColorDerivate(
      settings.buttons.reject.colors.background,
      2,
    )};
    --reject-button-background-color-3: ${getColorDerivate(
      settings.buttons.reject.colors.background,
      3,
    )};
    --reject--button-background-color-5: ${getColorDerivate(
      settings.buttons.reject.colors.background,
      5,
    )};
    --reject-button-text-color: ${settings.buttons.reject.colors.text};
    --reject-button-border-width: ${settings.buttons.reject.border.width}px;
    --reject-button-border-color-1: ${settings.buttons.reject.colors.border};
    --reject-button-border-color-2: ${getColorDerivate(
      settings.buttons.reject.colors.border,
      2,
    )};
    --reject-button-border-color-3: ${getColorDerivate(
      settings.buttons.reject.colors.border,
      3,
    )};

    `;
  }
  const IFRAME_INITIAL_CONTENT = `
  <!DOCTYPE html>
  <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <style>
        html, body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
          font-size: 14px;
          box-sizing: border-box;
        }
        body *, *:before, *:after {
          box-sizing: inherit;
        }
        input, textarea, select, button {
          font-size: 1rem;
          font-family: inherit;
        }
        body {
          line-height: 1;
        }
        :root {

          /*------------------------------------------------ ADD BUTTON SECTION START ------------------------------------------------*/
              --add-button-background-color-1: ${
                settings.buttons.add.colors.background
              };
              --add-button-background-color-2: ${getColorDerivate(
                settings.buttons.add.colors.background,
                2,
              )};
              --add-button-background-color-3: ${getColorDerivate(
                settings.buttons.add.colors.background,
                3,
              )};
              --add-button-background-color-5: ${getColorDerivate(
                settings.buttons.add.colors.background,
                5,
              )};
              --add-button-text-color: ${settings.buttons.add.colors.text};
              --add-button-border-width: ${settings.buttons.add.border.width}px;
              --add-button-border-color-1: ${
                settings.buttons.add.colors.border
              };
              --add-button-border-color-2: ${getColorDerivate(
                settings.buttons.add.colors.border,
                2,
              )};
              --add-button-border-color-3: ${getColorDerivate(
                settings.buttons.add.colors.border,
                3,
              )};
          /*------------------------------------------------ ADD BUTTON SECTION END ------------------------------------------------*/

          /*------------------------------------------------ CONTINUE BUTTON SECTION START ------------------------------------------------*/
              --continue-to-button-background-color-1: ${
                settings.buttons.continue_to.colors.background
              };
              --continue-to-button-background-color-2: ${getColorDerivate(
                settings.buttons.continue_to.colors.background,
                2,
              )};
              --continue-to-button-background-color-3: ${getColorDerivate(
                settings.buttons.continue_to.colors.background,
                3,
              )};
              --continue-to-button-background-color-5: ${getColorDerivate(
                settings.buttons.continue_to.colors.background,
                5,
              )};
              --continue-to-button-text-color: ${
                settings.buttons.continue_to.colors.text
              };
              --continue-to-button-border-width: ${
                settings.buttons.continue_to.border.width
              }px;
              --continue-to-button-border-color-1: ${
                settings.buttons.continue_to.colors.border
              };
              --continue-to-button-border-color-2: ${getColorDerivate(
                settings.buttons.continue_to.colors.border,
                2,
              )};
              --continue-to-button-border-color-3: ${getColorDerivate(
                settings.buttons.continue_to.colors.border,
                3,
              )};
          /*------------------------------------------------ CONTINUE BUTTON SECTION END ------------------------------------------------*/

          /*------------------------------------------------ REJECT BUTTON SECTION START ------------------------------------------------*/
             ${rejectButtonVariables}
          /*------------------------------------------------ REJECT BUTTON SECTION END ------------------------------------------------*/


          --primary-color-1: var(--add-button-background-color-1);
          --primary-color-2: var(--add-button-background-color-2);
          --primary-color-3: var(--add-button-background-color-3);
          --primary-color-5: var(--add-button-background-color-5);
          --readable-primary-color: var(--add-button-text-color);
        }
        ${css}
        ${simplebar}
      </style>
      <style id="settings-css">
         ${settings.custom_css}
      </style>
    </head >
    <body>
      <div></div>
    </body>
  </html >
    `;

  const onContentDidMount = () => {
    // Focus on iframe due to accessibility - so the tabIndex is set to the popup
    const focusInterval = setInterval(() => {
      const frames = Array.from(
        document.querySelectorAll('#candyrack-frame'),
      ) as HTMLIFrameElement[];
      const frame = frames.find((frame) => isElementVisible(frame));
      if (frame) {
        frame.focus();
        clearInterval(focusInterval);
      }
    }, 100);
  };

  return (
    <ReactFrame
      tabIndex={0}
      id="candyrack-frame"
      style={
        visible
          ? {
              display: 'block',
              width: '100%',
              height: '100%',
              position: 'fixed',
              top: 0,
              zIndex: 2147483647,
              bottom: 0,
              right: 0,
              left: 0,
              border: 'none',
            }
          : {
              display: 'none',
              width: 0,
              height: 0,
            }
      }
      initialContent={IFRAME_INITIAL_CONTENT}
      data-hj-allow-iframe
      contentDidMount={onContentDidMount}
    >
      {children}
    </ReactFrame>
  );
};

export default IFrame;
